// ForbiddenPage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 style={{ color: 'red' }}>403 Forbidden</h1>
      <p>You do not have permission to access this page.</p>
      <Button variant="contained" onClick={handleGoBack} color="primary">
        Go Back
      </Button>
    </div>
  );
};

export default ForbiddenPage;
